import { render, staticRenderFns } from "./ChallengeTeams.vue?vue&type=template&id=3117e63e&scoped=true"
import script from "./ChallengeTeams.vue?vue&type=script&lang=ts"
export * from "./ChallengeTeams.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117e63e",
  null
  
)

export default component.exports